module.exports = __webpack_public_path__ + "static/media/ajax-Loader.9be45b89.gif";